import { InputTypes } from '@cashier/cashier-model';

import { ItemEnricher } from './model';

export const PhoneFieldLocalizer: ItemEnricher = {
  shouldEnrich: (field, _) =>
    field.name === InputTypes.Phone || field.type === InputTypes.Phone,
  enrich: (field, { country, platform }) => {
    if (country === 'ZMB' && platform === '17') {
      field.params = {
        ...field.params,
        prefix: '+260',
        pattern: '/^\\d{9}$/',
        errorMessage:
          'Incorrect phone number format. Please enter your number without country/region code.',
      };
    }
  },
};
